import { MhsQuestionAndAnswer } from "./mhs-question-and-answer";
import { AddressMhs } from "./session/address-mhs";
import { ApplicantMhs } from "./session/applicant-mhs";
import { CoverageMhs } from "./session/coverage-mhs";
import { ElectronicCommunicationMhs } from "./session/electronic-communication-mhs";
import { EmployeeMhs } from "./session/employee-mhs";
import { PhysicianMhs } from "./session/physician-mhs";
import { EConsent } from "./ui/eConsent";

export class MhsApplicationResponse {
  mhsId: string;
  pdfId: string;
};

export class MhsApplication {
  mhsId:string;
  consented: boolean;
  policyNumber: string;
  groupName: string;
  adminUnit: string;
  formNumber: string;
  isNewGenericDynamicForm: boolean;
  companyId: string;
  econsent: EConsent;
  employee: EmployeeMhs;
  applicant: ApplicantMhs;
  physician?: PhysicianMhs;
  medicalHistory: {};
  newMedicalHistory: MhsQuestionAndAnswer[];
  agreedOrAcknowledged : string;
  electronicCommunication?: ElectronicCommunicationMhs;
};
